<template>

  <v-select
    :label="label"
    :items="options"
    :model-value="sortedModel"
    @update:model-value="e => model = e"
    :multiple="multiple"
    :clearable="clearable"
    :rules="rules"
  >

    <template v-slot:prepend-item v-if="multiple">

      <v-list-item>

        <v-btn density="compact" color="grey-darken-3" :text="$t('titles.all')" @click="model = [Weekday.Sun, Weekday.Mon, Weekday.Tue, Weekday.Wed, Weekday.Thu, Weekday.Fri, Weekday.Sat]" />
        <v-btn density="compact" color="grey-darken-3" class="ml-3" :text="$t('titles.weekdays')" @click="model = [Weekday.Mon, Weekday.Tue, Weekday.Wed, Weekday.Thu, Weekday.Fri]" />
        <v-btn density="compact" color="grey-darken-3" class="ml-3" :text="$t('titles.weekends')" @click="model = [Weekday.Sun, Weekday.Sat]" />

      </v-list-item>

    </template>

  </v-select>

</template>

<script setup lang="ts">

import { computed } from 'vue'
import { Weekday } from '../../types/misc'

interface Props {
  label: string
  multiple?: boolean
  clearable?: boolean
  rules?: undefined | any[]
}

const props = withDefaults(defineProps<Props>(), {
  multiple: false,
  clearable: false,
  rules: undefined
})

const weekdayOrder = [Weekday.Sun, Weekday.Mon, Weekday.Tue, Weekday.Wed, Weekday.Thu, Weekday.Fri, Weekday.Sat]

const model = defineModel<Weekday | Weekday[] | undefined>()

const sortedModel = computed<Weekday | Weekday[] | undefined>(() => {

  if (!props.multiple) {
    return model.value
  }

  return (model.value as number[]).toSorted((a, b) => weekdayOrder.indexOf(a) - weekdayOrder.indexOf(b))

})

const options = [
  // TODO: i18n
  {value: Weekday.Sun, title: 'Sun'}, {value: Weekday.Mon, title: 'Mon'}, {value: Weekday.Tue, title: 'Tue'},
  {value: Weekday.Wed, title: 'Wed'}, {value: Weekday.Thu, title: 'Thu'}, {value: Weekday.Fri, title: 'Fri'},
  {value: Weekday.Sat, title: 'Sat'},
]

</script>
